module.exports = __webpack_public_path__ + "assets/img/gzh.bf4d3ca5.png";